module.exports = __webpack_public_path__ + "static/media/vk.c533ae10.png";